module.exports = __webpack_public_path__ + "static/media/chatTabSelected.4d252542.png";